import { CSSProperties, memo } from 'react';
import Translate from '../Translate';

export interface CaptionProps {
  text_en?: string | undefined;
  text_bn?: string | undefined;
  color?: string;
  fontSize?: string;
  fontWeight?: string;
  style?: CSSProperties;
}

function Caption({
  text_en,
  text_bn,
  color,
  fontSize,
  fontWeight,
  style,
}: CaptionProps) {
  return (
    <p
      className={`text-${color} items-center break-words dark:text-white text-${fontSize} font-${fontWeight}`}
      style={style}
    >
      <Translate en={text_en} bn={text_bn} />
    </p>
  );
}

// Caption.defaultProps = {
//   text: 'Hello,World',
//   color: 'red-500',
//   fontSize: 'lg',
//   fontWeight: 'normal',
// };

export default memo(Caption);
